import React from 'react';
import { Badge } from '@/components/ui';
import type { InspectionStatus } from '../types/construction-qa.types';

interface Props {
  status: InspectionStatus;
  className?: string;
}

const statusConfig: Record<InspectionStatus, { label: string; color: string }> = {
  draft: { label: 'Bản thảo', color: 'bg-slate-100 text-slate-600' },
  in_progress: { label: 'Đang thực hiện', color: 'bg-blue-100 text-blue-600' },
  submitted: { label: 'Đã gửi', color: 'bg-amber-100 text-amber-600' },
  passed: { label: 'Đạt', color: 'bg-emerald-100 text-emerald-600' },
  failed: { label: 'Không đạt', color: 'bg-rose-100 text-rose-600' },
  rework_required: { label: 'Yêu cầu sửa', color: 'bg-orange-100 text-orange-600' },
  approved: { label: 'Đã duyệt', color: 'bg-indigo-100 text-indigo-600' },
  closed: { label: 'Đã đóng', color: 'bg-slate-900 text-white' },
  cancelled: { label: 'Đã hủy', color: 'bg-slate-200 text-slate-400' },
};

export const QaStatusBadge: React.FC<Props> = ({ status, className }) => {
  const config = statusConfig[status] || { label: status, color: 'bg-slate-100 text-slate-600' };
  
  return (
    <Badge className={`${config.color} border-transparent text-[10px] font-bold ${className}`}>
      {config.label}
    </Badge>
  );
};
